import React from 'react'
import './footer.css'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer_logo'>Riley Shimp</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer_socials">
      <a href="https://www.linkedin.com/in/rileyshimp/" target="_ blank"> <BsLinkedin/></a>
      <a href="https://github.com/RileyShimp" target="_ blank"> <FaGithub/> </a>
      </div>

      <div className="footer_copyright">
        <small>&copy; Riley Shimp. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer